import type { FC, PropsWithChildren } from 'react';
import { Client, Server } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { DarkTheme, BaseProvider } from 'baseui';
import { ToasterContainer, ToasterOverrides } from 'baseui/toast';

const getHydrateClass = () =>
  document.getElementsByClassName('_styletron_hydrate_') as HTMLCollectionOf<HTMLStyleElement>;

export const styletron =
  typeof window === 'undefined'
    ? new Server()
    : new Client({
        hydrate: getHydrateClass()
      });

const toasterOverrides: ToasterOverrides = {
  Root: {
    style: {
      zIndex: 9999
    }
  },
  ToastBody: {
    style: ({ $kind }) => {
      if ($kind === 'info') {
        return {
          maxWidth: '100%',
          width: '400px',
          backgroundColor: '#36fad7',
          color: '#111111'
        };
      }
      return {
        maxWidth: '100%',
        width: '400px'
      };
    }
  }
};

const BaseuiProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyletronProvider value={styletron}>
      <BaseProvider theme={DarkTheme}>
        {children}
        <ToasterContainer autoHideDuration={3000} overrides={toasterOverrides} />
      </BaseProvider>
    </StyletronProvider>
  );
};

export default BaseuiProvider;
